import { format } from 'date-fns';
import { Section, SectionRow } from '../../interfaces';
import { PaymentsGroup } from '../../types/payments';
import { getCleanedPhone } from '../global/helper';
import { getCustomerRelationDetailRows } from './customerModal';

export function getClientSection(
  group: Pick<PaymentsGroup, 'customer'>,
  button?: { text: string; action: (customerId: string) => void },
) {
  if (!group.customer) return null;

  const customerName = `${group.customer.user.firstName || ''} ${
    group.customer.user.lastName || ''
  }`.trim();

  // Reformat users phone number
  const finalPhoneNumber = getCleanedPhone(group.customer.user.phoneNumber);

  // Reformat users birthday
  let customerDob = '';
  if (group.customer.dob) {
    customerDob = group.customer.dob?.toString()?.split('T')[0];
  }

  const client: Section = {
    name: 'Client',
    rows: [
      {
        type: 'TEXT',
        label: 'Name',
        value: [customerName || ''],
      },
      {
        type: 'TEXT',
        label: 'Email',
        value: [group.customer.user.email || ''],
      },
      {
        type: 'PHONE',
        label: 'Phone',
        value: [finalPhoneNumber || ''],
      },
      {
        type: 'TEXT',
        label: 'Birthday',
        value: [
          customerDob
            ? format(new Date(`${customerDob}T00:00:00`), 'MM/dd/yyyy')
            : '',
        ],
      },
      {
        type: 'TEXT',
        label: 'IG Handle',
        value: [group.customer.user.igHandle || ''],
      },
      'internalNotes' in group.customer
        ? {
            type: 'TEXT',
            label: 'Internal Notes',
            value: [group.customer.internalNotes || ''],
          }
        : null,
      ...getCustomerRelationDetailRows(group.customer),
    ].filter(Boolean) as SectionRow[],
    buttonText: button?.text,
    buttonAction: button
      ? () => {
          if (!group.customer) return;
          button.action(group.customer?.customerId);
        }
      : undefined,
  };

  return client;
}
